import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=2a525960&scoped=true&"
import script from "./CopyRight.vue?vue&type=script&lang=js&"
export * from "./CopyRight.vue?vue&type=script&lang=js&"
import style0 from "./CopyRight.vue?vue&type=style&index=0&id=2a525960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a525960",
  null
  
)

export default component.exports